module.exports = __webpack_public_path__ + "static/media/sd-worx.2770ad9c.jpg";